<template>
  <criterion :entity-type="EntityType.STATUS" />
</template>

<script>
import Criterion from '@/components/forms/Criterion';
import { EntityType } from '@/enums/entityType.enum';

// @vuese
// Lista Kryteriów etapu
// @group Stage
export default {
  components: { Criterion },
  data() {
    return {
      EntityType
    };
  }
};
</script>
